import { render, staticRenderFns } from "./PRPost.vue?vue&type=template&id=e72ff25a&scoped=true&"
import script from "./PRPost.vue?vue&type=script&lang=js&"
export * from "./PRPost.vue?vue&type=script&lang=js&"
import style0 from "./PRPost.vue?vue&type=style&index=0&id=e72ff25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72ff25a",
  null
  
)

export default component.exports